import type { ValueGetterParams } from 'ag-grid-community';
import type { OptionsType } from '../../types/options';
import type { Language, SelectOption } from '../../types/common';

/**
 * organizationIdからフィルタ用の文字列を生成する。
 * contextにcurrentLang, organizationBaseが存在する必要がある。
 * 解決できなかった場合はidをstringとして返す。
 * @param params [ValueGetterParams]
 * @returns string
 */
const organizationIdFilterValueGetter = (params: ValueGetterParams) => {
  const value: number = params.getValue('organizationBaseId');
  const id: string = String(value);
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const bases: OptionsType<string>[] | undefined = params.context?.organizationBase;
  const targetBase: OptionsType<string> | undefined = bases ? bases.find((base) => base.code === id) : undefined;
  const filterValue: string = currentLang && targetBase ? (currentLang.value === 'ja' ? targetBase.nameJapanese : targetBase.nameEnglish ?? targetBase.nameJapanese) : id;
  // console.log(value, id, params.context, targetBase, filterValue);
  return filterValue;
};

export default organizationIdFilterValueGetter;
